import * as CryptoJS from "crypto-js";

export const encryptData = (msg: any) => {
  var key = CryptoJS.enc.Utf8.parse("JwCcWbUddtnjJiem");
  var iv = CryptoJS.enc.Utf8.parse("JwCcWbUddtnjJiem");
  var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(msg), key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const enc = "Encrypted ---:" + encrypted;
  return enc.slice(14);
};
export const decryptData = (msg: any) => {
  let _key = CryptoJS.enc.Utf8.parse("JwCcWbUddtnjJiem");
  let _iv = CryptoJS.enc.Utf8.parse("JwCcWbUddtnjJiem");

  return CryptoJS.AES.decrypt(msg, _key, {
    keySize: 128 / 8,
    iv: _iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};
